<template>

    <div
        class="container"
        v-if="!hasContactform"
    >
        <div class="content-body" v-html="content.data.content"></div>
    </div>
    <div class="container"
         v-else
    >
        <div class="row">
            <div class="col-6">
                <div class="content-body" v-html="content.data.content"></div>
            </div>

            <div
                class="col-6"
                v-if="!hasSubmitted"
            >
                <contactform
                    :contactform="content.data.contactform"
                ></contactform>
            </div>
            <div
                class="col-6"
                v-else
                v-html="contactformsubmitted"
            />
        </div>
    </div>

</template>

<script>

import Layout from "../../Shared/Layout";
import Contactform from '../../components/Contactform/Contactform';

export default {

    components: {
        Contactform,
    },

    computed: {
        hasContactform() {
            return !!this.content.data.contactform;
        },

        hasSubmitted() {
            return this.contactformsubmitted !== null;
        },
    },

    destroyed() {
        this.$pageHeader.show();
    },

    layout:Layout,

    metaInfo() {
        return {
            title:this.content.data.name,
            meta: [
                { name: 'description', content: this.content.data.meta_description },
                { name: 'keywords', content: this.content.data.meta_keywords },
            ],
        }
    },

    mounted() {
        this.$pageHeader.hide();
    },

    name:'OpenContent',

    props: {
        content: {
            required:true,
        },
        contactformsubmitted: {
            default:null,
        },
    },

}

</script>
